import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';

const AIAgents = () => {
  const navigate = useNavigate();

  // Mock data for AI agents
  const agents = [
    {
      id: 1,
      name: 'Customer Service Agent',
      description: 'AI-powered customer support for handling inquiries and resolving issues',
      type: 'Support',
      status: 'Active',
      performance: 95,
      avatar: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      )
    }
    ,
    {
      id: 2,
      name: 'RH',
      description: 'AI-powered RH agent for HR-related assistance and employee support',
      type: 'HR',
      status: 'Active',
      performance: 95,
      avatar: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      )
    }
    
  ];

  const getTypeColor = (type) => {
    const colors = {
      'Support': 'bg-gray-100 text-gray-800',
      'Analytics': 'bg-blue-100 text-blue-800',
      'Sales': 'bg-green-100 text-green-800',
      'Marketing': 'bg-purple-100 text-purple-800',
      'HR': 'bg-orange-100 text-orange-800'
    };
    return colors[type] || 'bg-gray-100 text-gray-800';
  };

  const handleCardClick = (agentId) => {
    navigate(`/ai-agents/${agentId}`);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <header className="bg-white border-b border-gray-200 px-8 py-6 flex-shrink-0">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-black">AI Agents</h1>
              <p className="text-gray-600 mt-1">Manage and interact with your AI agents</p>
            </div>
          </div>
        </header>

        {/* Content */}
        <div className="p-8">
          <div className="flex-1 overflow-auto">
            {/* Agents Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {agents.map((agent) => (
                <div
                  key={agent.id}
                  className="bg-white rounded-2xl border border-gray-200 hover:border-gray-300 transition-all duration-300 transform hover:scale-105 cursor-pointer"
                  onClick={() => handleCardClick(agent.id)}
                >
                  <div className="p-6">
                    {/* Agent Header */}
                    <div className="flex items-start justify-between mb-4">
                      <div className="flex items-center space-x-3">
                        <div className="w-12 h-12 bg-black rounded-xl flex items-center justify-center text-white text-2xl">
                          {agent.avatar}
                        </div>
                        <div>
                          <h3 className="text-lg font-semibold text-black">{agent.name}</h3>
                          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getTypeColor(agent.type)}`}>
                            {agent.type}
                          </span>
                        </div>
                      </div>
                      <div className="text-right">
                        <div className="text-sm text-gray-500">Performance</div>
                        <div className="text-lg font-semibold text-black">{agent.performance}%</div>
                      </div>
                    </div>

                    {/* Description */}
                    <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                      {agent.description}
                    </p>

                    {/* Status */}
                    <div className="flex items-center justify-between mb-4">
                      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        {agent.status}
                      </span>
                    </div>

                    {/* Actions */}
                    <div className="flex space-x-2">
                      <button
                        className="flex-1 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors duration-200 text-sm font-medium"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(agent.id);
                        }}
                      >
                        View Details
                      </button>
                      <button
                        className="px-4 py-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 transition-colors duration-200"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIAgents;
